import React from "react"
import QuickSearchCompletionItem from "../Components/QuickSearchCompletionItem"
import { translate } from '../Services/translation';

export default ({ completionSuggestions, query, nameSuggestions }) => {
    return query.length > 0 && <div className="quickSearch_suggestions_wrapper">
        {completionSuggestions.length > 0 && <span>{translate('global.search.proposal')}:</span>}
        {nameSuggestions.length > 0 && completionSuggestions.length <= 0 && <span>{translate('global.did.you.mean')}</span>}
        <ul className="">
            {completionSuggestions.length > 0 && completionSuggestions.map(completionSuggestion => <QuickSearchCompletionItem className="quick-search-result__item" completionSuggestion={completionSuggestion} query={query} />)}
            {nameSuggestions.length > 0
                && completionSuggestions <= 0
                && nameSuggestions.map(nameSuggestion => <QuickSearchCompletionItem className="quick-search-result__item quick-search-Correction_item" completionSuggestion={nameSuggestion} query={query} />)}
        </ul>
    </div>
}